<template>
    <div>
        <label :for="id" class="dark:text-white text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" v-if="label">{{ label }}</label>
        <div class="relative" :class="{'mt-2.5': label}">
            <input 
                v-bind="$attrs"
                :id="id"
                type="text" 
                :name="name" 
                :class="[cn('dark:text-gray-300 dark:bg-[#2c2e32] !ring-0 w-full px-3 py-2.5 rounded-md sm:text-sm', $attrs.class!), {'border border-red-500 focus:border-red-500': errorMessage, 'border border-neutral-200 focus:border-neutral-200 dark:border-0 focus:border-0': !errorMessage}]" 
                v-maska:inputValue.unmasked
                :value="inputValue"
                data-maska-number-unsigned
                @input="handleChange(inputValue, false)" 
                @blur="handleBlur"
            />
            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="errorMessage">
                <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>
        <p class="text-red-500 font-medium text-sm mt-2.5" v-if="errorMessage">
            {{ errorMessage }}
        </p>
    </div>
</template>
 
<script setup lang="ts">
import { useField } from 'vee-validate'
import { cn } from '@/lib/utils'

const id = useId()

const props = defineProps({
    label: {
        type: String,
        default: null
    },
    name: {
        type: String,
        required: true
    },
    modelValue: String
})

const name = toRef(props, 'name')

const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    setErrors
} = useField(name, undefined, {
    syncVModel: true
})

watch(() => inputValue.value, () => {
    setErrors([])
})

defineOptions({
    inheritAttrs: false
})

defineExpose({ inputValue })
</script>